import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { OfflineAlert } from "./components/OfflineAlert";
import App from './App'
import './index.css'

// Cargar Eruda solo en desarrollo (o con ?debug=true) y en hosts locales
if (
  import.meta.env.DEV && (
    window.location.hostname === 'local.quattropy.com' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('192.168.') ||
    window.location.search.includes('debug=true')
  )
) {
  (function () {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/eruda';
    s.onload = function () {
      try {
        (window as any).eruda?.init();
        console.log('🔧 Eruda debugger cargado para desarrollo');
      } catch (e) {
        console.log('Error cargando Eruda:', e);
      }
    };
    document.body.appendChild(s);
  })();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <OfflineAlert />
    <App />
  </StrictMode>
);